import * as ActionTypes from '../Forgot';
import { CALL_API } from "../../../middleware/api";
export function openForgotModal() {
    return {
        type: ActionTypes.OPEN_FORGOT_MODAL
    };
}
export function closeForgotModal() {
    return {
        type: ActionTypes.CLOSE_FORGOT_MODAL
    };
}
function fetchRecoverPassword(data) {
    var _a;
    return _a = {
            type: ActionTypes.RECOVER_PASSWORD
        },
        _a[CALL_API] = {
            endpoint: '/recovery/init',
            method: 'post',
            types: [
                ActionTypes.SUCCESS_RECOVER_PASSWORD,
                ActionTypes.FAILURE_RECOVER_PASSWORD
            ],
            data: data
        },
        _a;
}
export function recoverPassword(data) {
    return function (dispatch) {
        dispatch(fetchRecoverPassword(data));
    };
}
export function recoverPasswordUZ(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.RECOVER_UZ_PASSWORD
            },
            _a[CALL_API] = {
                endpoint: "/recovery/check-available",
                method: 'post',
                types: [
                    ActionTypes.SUCCESS_RECOVER_UZ_PASSWORD,
                    ActionTypes.FAILURE_RECOVER_UZ_PASSWORD
                ],
                data: data
            },
            _a));
    };
}
export function smsRecoverStatus(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.FETCH_SMS_RECOVERY_STATUS
            },
            _a[CALL_API] = {
                endpoint: "/recovery/code-status",
                method: 'post',
                types: [
                    ActionTypes.SUCCESS_FETCH_SMS_RECOVERY_STATUS,
                    ActionTypes.FAILURE_FETCH_SMS_RECOVERY_STATUS
                ],
                data: data
            },
            _a));
    };
}
export function smsRecoverConfirm(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.FETCH_SMS_RECOVERY_CONFIRM
            },
            _a[CALL_API] = {
                endpoint: "/recovery/code-confirm",
                method: 'post',
                types: [
                    ActionTypes.SUCCESS_FETCH_SMS_RECOVERY_CONFIRM,
                    ActionTypes.FAILURE_FETCH_SMS_RECOVERY_CONFIRM
                ],
                data: data
            },
            _a));
    };
}
export function closeSMSRecoverModal() {
    return {
        type: ActionTypes.CLOSE_SMS_RECOVER_MODAL
    };
}
export function uidRecoverConfirm(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.FETCH_UID_RECOVERY_CONFIRM
            },
            _a[CALL_API] = {
                endpoint: "/recovery/uid-confirm",
                method: 'post',
                types: [
                    ActionTypes.SUCCESS_FETCH_UID_RECOVERY_CONFIRM,
                    ActionTypes.FAILURE_FETCH_UID_RECOVERY_CONFIRM
                ],
                data: data
            },
            _a));
    };
}
export function statusJoin(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.FETCH_JOIN_STATUS
            },
            _a[CALL_API] = {
                endpoint: "/recovery/uid-status",
                method: 'post',
                types: [
                    ActionTypes.SUCCESS_FETCH_JOIN_STATUS,
                    ActionTypes.FAILURE_FETCH_JOIN_STATUS
                ],
                data: data
            },
            _a));
    };
}



// WEBPACK FOOTER //
// ./src/actions/auth/creators/Forgot.js